export default {
  title: 'Product',

  labels: {
    addAttributeManually: 'Enable add attribute to product manually',
    unitPriceVatInclude: 'Unit price vat include'
  },

  notifications: {
    edit: {
      success: 'Product information has been updated successfully',
      error: 'Update product information has error'
    }
  }
}
